import { forwardRef } from 'react';

import QuillEditorV3 from 'hb-react/shared/components/DesignSystem/QuillEditor/indexV3';
import type {
  QuillEditorV3Props,
  QuillEditorV3Ref,
} from 'hb-react/shared/components/DesignSystem/QuillEditor/types';

const QuillEditorWrappedV3 = forwardRef<QuillEditorV3Ref, QuillEditorV3Props>(
  ({ options, ...otherProps }, ref) => (
    <QuillEditorV3 ref={ref} options={options} {...otherProps} />
  ),
);

export default QuillEditorWrappedV3;
